export default __webpack_public_path__ + "static/media/49.7527b770.jpg";